import { ADMIN, MODERATOR } from './roles';

export const ADMIN_ROLES = [
    { id: ADMIN, value: 'Администратор', color: 'green' },
    { id: MODERATOR, value: 'Модератор', color: 'blue' }
];
